import React, { useState, useEffect } from "react";
import { Button, CircularProgress, MenuItem, TextField } from "@mui/material";
import ActionModal from "./ActionModal";
import toast from "react-hot-toast";

const AccountStatusModal = ({ open, onClose, account, onSave, canEdit }) => {

    const readOnly = account?.verificationStatus !== 0 || !canEdit;

    const [status, setStatus] = useState(0);
    const [remark, setRemark] = useState("");
    const [loading, setLoading] = useState(false);


    // Load data properly when modal opens
    useEffect(() => {
        if (open && account) {
            setStatus(account.verificationStatus ?? 0);
            setRemark(account.remark ?? "");
            setLoading(false);
        }
    }, [open, account]);

    const handleSave = async () => {
        if (readOnly) {
            onClose();
            return;
        }

        if (!remark.trim()) {
            toast.error("Remark is required.");
            return;
        }

        setLoading(true);
        try {
            await onSave({ verificationStatus: status, remark });
            setLoading(false);
        } catch {
            setLoading(false);
        }
    };

    return (
        <ActionModal
            open={open}
            onClose={onClose}
            title={readOnly ? "View Account Status" : "Update Account Status"}
            actions={
                <>
                    <Button onClick={onClose} color="error" variant="contained" sx={{ mr: 1 }} disabled={loading}
                    >
                        Close
                    </Button>

                    {!readOnly && (
                        <Button onClick={handleSave} color="primary" variant="contained" disabled={loading}>
                            {loading ? (
                                <CircularProgress size={22} sx={{ color: "white" }} />
                            ) : (
                                "Save"
                            )}                        </Button>
                    )}
                </>
            }
        >
            <TextField
                select
                fullWidth
                label="Status"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                sx={{ mb: 2 }}
                disabled={readOnly || loading}
            >
                <MenuItem value={0}>Pending</MenuItem>
                <MenuItem value={1}>Verified</MenuItem>
                <MenuItem value={2}>Rejected</MenuItem>
            </TextField>

            <TextField
                fullWidth
                multiline
                rows={3}
                label="Remark"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                disabled={readOnly || loading}
                required={!readOnly}
            />
        </ActionModal>
    );
};

export default AccountStatusModal;
